import { node } from 'prop-types';
import { createContext, useEffect } from 'react';

import { appService } from 'services';

export const AppThemeContext = createContext();

const ThemeProvider = ({ children }) => {
  const brand = appService.brand().toLowerCase();

  useEffect(() => {
    // Set the tailwind theme based on the current host
    document.querySelector('html').setAttribute('data-theme', appService.isTouloisirs() ? 'touloisirs' : 'arrivaj');

    setFavicon();
    setManifest();
    setMetaThemeColor();
  }, [window.location.host]);

  const setFavicon = () => {
    const faviconEl = document.getElementById('favicon');
    const favicon16El = document.getElementById('favicon-16');
    const favicon32El = document.getElementById('favicon-32');
    const appleFaviconEl = document.getElementById('favicon-apple-touch');
    const safariFaviconEl = document.getElementById('safari-pinned-icon');

    faviconEl.href = `/${brand}/${brand}-favicon.ico`;
    favicon16El.href = `/${brand}/${brand}-favicon-16x16.png`;
    favicon32El.href = `/${brand}/${brand}-favicon-32x32.png`;
    appleFaviconEl.href = `/${brand}/${brand}-apple-touch-icon.png`;
    safariFaviconEl.href = `/${brand}/${brand}-safari-pinned-tab.svg`;
  };

  const setManifest = () => {
    const manifestEl = document.getElementById('manifest');
    manifestEl.href = `/${brand}/${brand}-manifest.json`;
  };

  const setMetaThemeColor = () => {
    const primaryColor = window?.getComputedStyle(document.documentElement)?.getPropertyValue('--color-primary-500');
    const themeColorEl = document.getElementById('theme-color');
    const tileColorEl = document.getElementById('tile-color');
    themeColorEl.content = primaryColor ?? '#00b2a9';
    tileColorEl.content = primaryColor ?? '#00b2a9';
  };

  return <AppThemeContext.Provider value={{}}>{children}</AppThemeContext.Provider>;
};

ThemeProvider.propTypes = {
  children: node
};

export default ThemeProvider;
